<template>
  <div class="dialogwrap">
    <el-dialog
      :visible.sync="dialogTableVisible"
      :before-close="closedialog"
      :close-on-click-modal="false"
      width="682px"
      :title="dialogTitle"
    >

      <el-dialog width="700px" :visible.sync="innerVisible" append-to-body>
        <div>
          <img style="width: 100%; height: 100%" :src="setUrl" alt="" />
        </div>
      </el-dialog>
      <div>
<!--        <el-tabs v-model="activeName" @tab-click="handleClick">-->
<!--          <el-tab-pane label="企业认证" name="first">-->
<!--            <div class="count_center">-->
<!--              <p class="title">请上传公司营业执照</p>-->
<!--              <div class="license bg_wrap" @mouseleave="hoverType = false">-->
<!--                <img-->
<!--                  class="setImg"-->
<!--                  @mouseover="hoverType = true"-->
<!--                  v-show="imgUrl"-->
<!--                  style="width: 100%"-->
<!--                  :src="imgUrl"-->
<!--                  alt=""-->
<!--                />-->
<!--                <div v-if="hoverType" class="Imgmodal">-->
<!--                  <i-->
<!--                    @click="setinnerImg(imgUrl)"-->
<!--                    style="font-size: 28px; color: #ffffff"-->
<!--                    class="el-icon-zoom-in"-->
<!--                  ></i>-->
<!--                  <i-->
<!--                    @click="delenterpriseImg()"-->
<!--                    style="font-size: 28px; color: #ffffff"-->
<!--                    class="el-icon-delete"-->
<!--                  ></i>-->
<!--                </div>-->
<!--                <div class="fileInputContainer">-->
<!--                  点击上传营业执照-->
<!--                  <input-->
<!--                    id="lenterprisefile"-->
<!--                    ref="lenterprise"-->
<!--                    @change="UploadImg($event, 'license')"-->
<!--                    class="fileInput"-->
<!--                    type="file"-->
<!--                  />-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </el-tab-pane>-->
          <!-- <el-tab-pane label="个人认证" name="second">
            <div class="count_center">
              <p class="title">请上传本人有效身份证</p>
              <div class="LR_center">
                <div
                  class="sfz_bg_z bg_wrap"
                  @mouseleave="careShowType_z = false"
                >
                  <img
                    class="setImg"
                    @mouseover="careShowType_z = true"
                    v-show="cardImg_z"
                    style="width: 100%"
                    :src="cardImg_z"
                    alt=""
                  />
                  <div v-if="careShowType_z && cardImg_z" class="Imgmodal">
                    <i
                      @click="setinnerImg(cardImg_z)"
                      style="font-size: 28px; color: #ffffff"
                      class="el-icon-zoom-in"
                    ></i>
                    <i
                      @click="delcardImg_z()"
                      style="font-size: 28px; color: #ffffff"
                      class="el-icon-delete"
                    ></i>
                  </div>
                  <div class="fileInputContainer">
                    点击上传身份证正面
                    <input
                      id="delcardImg_zfile"
                      ref="lenterprise"
                      @change="UploadImg($event, 'cardImg_z')"
                      class="fileInput"
                      type="file"
                    />
                  </div>
                </div>
                <div
                  class="sfz_bg_f bg_wrap"
                  @mouseleave="careShowType_f = false"
                >
                  <img
                    class="setImg"
                    @mouseover="careShowType_f = true"
                    v-show="cardImg_f"
                    style="width: 100%"
                    :src="cardImg_f"
                    alt=""
                  />
                  <div v-if="careShowType_f && cardImg_f" class="Imgmodal">
                    <i
                      @click="setinnerImg(cardImg_f)"
                      style="font-size: 28px; color: #ffffff"
                      class="el-icon-zoom-in"
                    ></i>
                    <i
                      @click="delcardImg_f()"
                      style="font-size: 28px; color: #ffffff"
                      class="el-icon-delete"
                    ></i>
                  </div>
                  <div class="fileInputContainer">
                    点击上传身份证反面
                    <input
                      id="cardImg_ffile"
                      ref="lenterprise"
                      @change="UploadImg($event, 'cardImg_f')"
                      class="fileInput"
                      type="file"
                    />
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane> -->
<!--        </el-tabs>-->
        <template v-if="realNameType === 2">
          <el-input
            :disabled="userState !== -1 && userState !== 2"
            class="real-name-remark"
            placeholder="请输入认证备注"
            type="textarea"
            v-model="remarks"
          ></el-input>
        </template>
        <template v-else>
          <div class="license bg_wrap" @mouseleave="hoverType = false">
            <img
              class="setImg"
              @mouseover="hoverType = true"
              v-show="imgUrl"
              style="width: 100%"
              :src="imgUrl"
              alt=""
            />
            <div style="text-align:center;" class="uploadImag" @click="selectFile" v-if="!imgUrl">
              <img
                style="width: 42px;height: 42px;"
                :src="ossPath + '/pages/userCenter/upload.png'"
                alt=""
              />
              <div style="font-size: 9px;font-weight: 500;color:#666;margin-top: 17px;">
                点击上传公司营业执照
                <input
                  id="lenterprisefile"
                  ref="lenterprise"
                  @change="UploadImg($event, 'license')"
                  class="fileInput"
                  type="file"
                />
              </div>
            </div>
            <div v-if="hoverType" class="Imgmodal">
              <i
                @click="setinnerImg(imgUrl)"
                style="font-size: 28px; color: #ffffff"
                class="el-icon-zoom-in"
              ></i>
              <i
                @click="delenterpriseImg()"
                style="font-size: 28px; color: #ffffff;margin-left: 40px;"
                class="el-icon-delete"
                v-if="authenticationInfoDTO.state != 2"
              ></i>
            </div>
<!--            <div class="fileInputContainer">-->
<!--              点击上传营业执照-->
<!--              <input-->
<!--                id="lenterprisefile"-->
<!--                ref="lenterprise"-->
<!--                @change="UploadImg($event, 'license')"-->
<!--                class="fileInput"-->
<!--                type="file"-->
<!--              />-->
<!--            </div>-->
          </div>
        </template>
        <div class="count_center">
<!--          <div style="margin-top: 12px; color: #999999">-->
<!--            照片支持JPEG、JPG、PNG格式，最大文件不超过2M。-->
<!--          </div>-->
          <template v-if="Authorization.authenticationInfoDTO.type !== 7&&!reSubmit">
            <div class="LR_center" style="margin-top: 34px">
              <i
                v-show="authenticationInfoDTO.state != 3"
                class="el-icon-warning"
                style="color: #f56c6c; font-size: 20px"
              ></i>
              <i
                v-show="authenticationInfoDTO.state == 3"
                class="el-icon-success"
                style="color: #67c23a; font-size: 20px"
              ></i>
              <span style="margin-left: 5px" v-if="!reSubmit">{{
                authenticationInfoDTO.state == -1
                  ? "未认证"
                  : authenticationInfoDTO.state == 1
                  ? "已提交相关资料，审核中"
                  : authenticationInfoDTO.state == 2
                  ? "认证失败"
                  : "已认证"
              }}</span>
            </div>
            <span style="color: #f56c6c" v-if="!reSubmit">{{
              authenticationInfoDTO.reviewRemark
            }}</span>
          </template>

          <div class="LR_center" style="padding: 19px 0">
<!--            <el-button @click="closedialog">关闭</el-button>-->
            <el-button type="primary" @click="Qdupform()" class="submit-button" v-if="authenticationInfoDTO.state != 1 && authenticationInfoDTO.state != 3">{{
              authenticationInfoDTO.state == 2 && !reSubmit ? "重新提交" : "提交"
            }}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import qs from "qs";
// import {ossPath} from "../../../../../devParams";
import {mapState} from "vuex";
import { sendCustomerOperationRecord } from "@/assets/js/utils";

export default {
  props: {
    dialogTableVisible: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    realNameType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      authenticationInfoDTO: {},
      setUrl: "",
      activeName: "first",
      imgUrl: "",
      hoverType: false,
      careShowType_z: false,
      careShowType_f: false,
      innerVisible: false,
      cardImg_z: "",
      cardImg_f: "",
      Licfiles:null,
      file_sfzz:null,
      file_sfzf:null,
      dialogTitle: '销售代理认证',
      remarks: '',
      reSubmit: false
    };
  },
  watch: {
    realNameType(val) {
      console.log(val)
      if (val === 1) {
        this.dialogTitle = '销售代理认证'
      }
      // else if (val === 2) {
      //   this.dialogTitle = '分销大使认证'
      // }
      else if (val === 3) {
        this.dialogTitle = '省代认证'
      } else if (val === 4) {
        this.dialogTitle = '市代/产业带加盟商入驻'
      } else if (val === 7) {
        this.dialogTitle = '询价用户认证'
      } else {
        this.dialogTitle = '未知类型，请联系客服'
      }
    }
  },
  computed: {
    ...mapState(["Authorization"]),
    userState() {
      return this.authenticationInfoDTO.state
    },
    userType() {
      return this.authenticationInfoDTO.type
    }
  },
  methods: {
    parentHandleclick() {
      let user = this.sessionGetUserInfo();
      this.$http
        .get("/user/getUserLoginInfo/1", {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            token: user.token,
          },
        })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.info(res.data.message);
            return;
          }
          this.authenticationInfoDTO = res.data.data.authenticationInfoDTO;
          this.remarks = this.authenticationInfoDTO.remarks
          console.log('this.authenticationInfoDTO: ', this.authenticationInfoDTO);
          if (this.authenticationInfoDTO.type) {
            if (this.authenticationInfoDTO.type == 1) {
              //企业
              this.activeName = "first";
              this.imgUrl = this.authenticationInfoDTO.fileUrls[0].fileUrl;
            } else {
              this.activeName = "second";
              this.cardImg_z = this.authenticationInfoDTO.fileUrls[0].fileUrl;
              this.cardImg_f = this.authenticationInfoDTO.fileUrls[1].fileUrl;
            }
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    Qdupform() {
      if (this.authenticationInfoDTO.state == 2 && !this.reSubmit) {
        this.imgUrl = ''
        this.reSubmit = true
        return
      }
      let form = new FormData();

      // if (this.activeName == "first") {
      //   //企业
      //   if (this.imgUrl&&!this.Licfiles) return this.$message.info("请重新上传公司营业执照");
      //   if (this.imgUrl == "") return this.$message.info("请上传公司营业执照");
      //   form.append("file", this.Licfiles);
      // } else {
      //   if (this.cardImg_z&&!this.file_sfzz) return this.$message.info("请重新上传身份证正面");
      //   if (this.cardImg_f&&!this.file_sfzf) return this.$message.info("请重新上传身份证反面");
      //   if (this.cardImg_z == "") return this.$message.info("请上传身份证正面");
      //   if (this.cardImg_f == "") return this.$message.info("请上传身份证反面");
      //   form.append("file", this.file_sfzz);
      //   form.append("file", this.file_sfzf);
      // }
      if (this.realNameType !== 2) {
        if (this.imgUrl&&!this.Licfiles) return this.$message.info("请重新上传公司营业执照");
        if (this.imgUrl == "") return this.$message.info("请上传公司营业执照");
        form.append("file", this.Licfiles);
      } else {
        form.append('remarks', this.remarks)
      }
      form.append("type", this.realNameType);
      form.append('customerid', this.$store.state.Authorization.customerid)

      console.log("form: ", form);

      if (this.Authorization.authenticationInfoDTO.type === 7) {
        form.append("fromTemporaryVisitor", 1);
      }
      const typeOb = {
        1: '销售代理认证',
        2: '分销大使认证',
        7: '货代询价用户认证',
        6: '城市合伙人认证'
      }
      sendCustomerOperationRecord('提交认证资料', typeOb[this.realNameType])
      this.axios
        .post(`/customer/addRealNameAuthentication`, form)
        .then((res) => {
          if (res.data.code == "200") {
            this.$message({
              message: "已提交相关资料，审核中",
              type: "success",
            });
            this.$emit("closedialog", false);
            this.$emit("getUserLoginInfo");
            this.reSubmit = false
          } else {
            this.$message({
              message: res.data.message,
              type: "info",
            });
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    setinnerImg(imgurl) {
      this.setUrl = imgurl;
      this.innerVisible = true;
    },
    hoverImg() {
      this.hoverType = !this.hoverType;
      this.careShowType_z = !this.careShowType_z;
      this.careShowType_f = !this.careShowType_f;
    },
    closedialog() {
      this.$emit("closedialog", false);
      this.imgUrl = "";
      this.cardImg_z = "";
      this.cardImg_f = "";
      this.reSubmit = false
    },
    UploadImg(event, type) {
      console.log(event)
      if (!event.target.files[0]) return;
      let file = event.target.files[0];
      let mb = 20;
      let maxSize = 1024 * 1024 * mb;
      if(file.size >  maxSize){
        return this.$message.error(`图片不能大于${mb}MB`)
      }
      let url = "";
      var reader = new FileReader();
      reader.readAsDataURL(file);
      let that = this;
      reader.onload = function (e) {
        url = this.result.substring(this.result.indexOf(",") + 1);
        if (type == "license") {
          that.imgUrl = "data:image/png;base64," + url;
          that.Licfiles = event.target.files[0];
        }
        if (type == "cardImg_z") {
          that.cardImg_z = "data:image/png;base64," + url;
          that.file_sfzz = event.target.files[0];
        }
        if (type == "cardImg_f") {
          that.cardImg_f = "data:image/png;base64," + url;
          that.file_sfzf = event.target.files[0];
        }
      };
    },
    delenterpriseImg() {
      let lenterprisefile = document.getElementById("lenterprisefile");
      if (!lenterprisefile) {
        this.imgUrl = ''
      } else {
        lenterprisefile.value = "";
        this.imgUrl = "";
        this.hoverType = false;
      }
    },
    delcardImg_z() {
      let delcardImg_zfile = document.getElementById("delcardImg_zfile");
      delcardImg_zfile.value = "";
      this.cardImg_z = "";
      this.careShowType_z = false;
    },
    delcardImg_f() {
      let cardImg_ffile = document.getElementById("cardImg_ffile");
      cardImg_ffile.value = "";
      this.cardImg_f = "";
      this.careShowType_f = false;
    },
    handleClick() {},
    selectFile() {
      const input = document.getElementById('lenterprisefile')
      input.click()
    }
  },
  created() {},
  mounted() {},
};
</script>
<style scoped >
.dialogwrap >>> .el-dialog__body {
  padding: 0 20px !important;
}
/* 垂直居中 */
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* column垂直 */
  flex-direction: column;
}
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.title {
  padding: 24px 0;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
}
.bg_wrap {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-bottom: 30px;
  box-sizing: border-box;
  margin: 0 auto;
}
.license {
  width: 183px;
  height: 220px;
  /*background: url("../../../../assets/UserManage/license.png");*/
  background: #F5F5F5;
}
.sfz_bg_z {
  width: 238px;
  height: 146px;
  background: url("../../../../assets/UserManage/cd_card_z.png");
  margin: 0 15px;
}
.sfz_bg_f {
  width: 238px;
  height: 146px;
  background: url("../../../../assets/UserManage/cd_card_f.png");
  margin: 0 15px;
}
.button {
  width: 100%;
  height: 34px;
  background: #fecf5e;
  border-radius: 0px 0px 10px 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: center;
  font-weight: bold;
  color: #fff5df;
  line-height: 34px;
}
/* demo */
.fileInputContainer {
  /*background:url();*/
  position: relative;
  width: 100%;
  height: 34px;
  background: #fecf5e;
  border-radius: 0px 0px 10px 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: center;
  font-weight: bold;
  color: #fff5df;
  line-height: 34px;
}
.dialogwrap >>> .el-dialog__headerbtn {
  z-index: 99 !important;
}
.fileInput {
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: pointer;
}
.setImg {
  position: relative;
}
.Imgmodal {
  padding: 0 35px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: black;
  opacity: 0.5;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}

.real-name-remark >>> .el-textarea__inner {
  width: 629px;
  height: 176px;
  background-color: #F5F5F5;
  border: unset;
}

.submit-button {
  width: 166px;
  height: 30px;
  border-radius: 15px;
  line-height: 1;
  padding: 0;
  font-size: 10px;
  font-weight: bold;
}

.uploadImag:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/accountManage/UserManageinfo/UserManageinfo.vue